import React from 'react'

const Loader = () => {
  return (
    <div className='loader'>
      <div className="loader__inner"></div>
    </div>
  )
}

export default Loader